/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable react-hooks/exhaustive-deps */
import { Alert, Button, List, Modal, Skeleton } from 'antd';
import {
  useAppDispatch,
  useAppNavigation,
  useAuthState,
  useBusinessState,
  useModalState,
} from '@core/.';
import { closeModal } from '@core/features';
import { selectLocation } from '@core/features/business/thunks/selectLocation.thunk';
import { Location } from '@core/models';
import { CheckCircleOutlined, UserSwitchOutlined } from '@ant-design/icons';
import Lottie from 'lottie-react';
import { ReviewLottieFile } from '@components/animations/lottie';
import { logout } from '@core/features/auth/thunks';
import { useMemo } from 'react';
import { LoadableContainer } from '..';
import { getGoogleIncrementalUrl } from '@constants/auth';
import { useLocation } from 'react-router';

type Props = {};

const WelcomeSelectLocationModal = (_: Props) => {
  const dispatch = useAppDispatch();
  const { navigate } = useAppNavigation();
  const { user } = useAuthState();
  const { welcomeLocationModal } = useModalState();
  const { locations, isLoading, error } = useBusinessState();

  const location = useLocation();
  let from = ((location.state as any)?.from?.pathname as string) || '/';

  const onSelectLocation = async (locationName: string) => {
    try {
      await dispatch(selectLocation(locationName));
      navigate('home');
      handleCloseModal();
    } catch (error) {
      console.log(error);
    }
  };

  const handleCloseModal = () => {
    dispatch(
      closeModal({
        modalName: 'welcomeLocationModal',
      })
    );
  };

  const handleSwitchAccount = () => {
    dispatch(logout());
  };

  const renderDescription = (item: Location) => {
    return `${item.storefrontAddress?.addressLines[0]}, ${item.storefrontAddress?.locality}, ${item.storefrontAddress?.regionCode}`;
  };

  const noPermissionGranted = useMemo(() => error === 'MISSING_PERMISSION', [error]);

  return (
    <Modal
      title={'Welcome to Review Circle!'}
      centered
      closable={false}
      open={welcomeLocationModal}
      footer={[]}
      width={500}>
      <LoadableContainer isLoading={isLoading} loadComponent={<Skeleton />}>
        {noPermissionGranted ? (
          <div>
            <p>
              We are going to help grow your reviews and online presence fast. To get started,
              please connect your Google Business profiles.
            </p>
            <img src="gmb-logo.jpg" alt="Google My Business" style={{ margin: '20px 0px' }} />
            <Button
              type="primary"
              style={{ width: '100%', marginTop: 20 }}
              href={getGoogleIncrementalUrl(user?.email.toString() || '', from)}>
              Connect your Google Business
            </Button>
            <Button style={{ width: '100%', marginTop: 10 }} onClick={handleSwitchAccount}>
              <UserSwitchOutlined /> Switch Account
            </Button>
          </div>
        ) : (
          <div>
            <p>
              Please select your preferred location to begin exploring and enjoying all the amazing
              features our platform has to offer.
            </p>
            <LoadableContainer
              isLoading={locations.length === 0}
              loadComponent={
                <div style={{ marginTop: 10 }}>
                  <Alert
                    message={
                      <span>
                        No location found. Please find add{' '}
                        <span style={{ fontWeight: 'bold' }}>{user?.email}</span> as manager of your
                        business locations following this guide:
                        <a
                          style={{ marginLeft: 5 }}
                          href="https://support.google.com/business/answer/3403100?hl=en">
                          Learn how to add manager to your business.
                        </a>
                      </span>
                    }
                    type="warning"
                    showIcon
                  />
                </div>
              }>
              <Lottie
                style={{
                  height: 300,
                }}
                animationData={ReviewLottieFile}
              />
              <List
                dataSource={locations}
                pagination={{
                  onChange: page => {
                    console.log(page);
                  },
                  pageSize: 5,
                  hideOnSinglePage: true,
                }}
                renderItem={(item, index) => (
                  <List.Item
                    key={item.name}
                    actions={[
                      !!user && user.selected_location?.title !== item?.title ? (
                        <Button
                          type="primary"
                          shape="round"
                          onClick={() => onSelectLocation(item.name)}>
                          Select
                        </Button>
                      ) : (
                        <CheckCircleOutlined style={{ fontSize: 20 }} />
                      ),
                    ]}>
                    <List.Item.Meta
                      title={<p>{item.title}</p>}
                      description={renderDescription(item)}
                    />
                  </List.Item>
                )}
              />
            </LoadableContainer>
            <Button
              style={{ width: '100%', marginTop: 10 }}
              type="primary"
              onClick={handleSwitchAccount}>
              <UserSwitchOutlined /> Switch Account
            </Button>
          </div>
        )}
      </LoadableContainer>
    </Modal>
  );
};

export default WelcomeSelectLocationModal;
